import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
export var USER_GROUPS_ARRAY = [{
  id: 1,
  name: "AdminNotConsultant",
  value: "adminNotConsultant"
}, {
  id: 2,
  name: "ConsultantOrHolding",
  value: "consultantOrHolding"
}, {
  id: 3,
  name: "Individual",
  value: "individual"
}, {
  id: 4,
  name: "Professional",
  value: "professional"
}, {
  id: 5,
  name: "Wholesaler",
  value: "wholesaler"
}];
export var USER_GROUPS = USER_GROUPS_ARRAY.reduce(function (acc, group) {
  var key = group.name.charAt(0).toLowerCase() + group.name.slice(1);
  acc[key] = group;
  return acc;
}, {});